import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { SegmentController } from '@tcc/crate';
import { APPLICATION_FORMAT } from 'constants/values';
import { getMessage } from 'util/locale';

export const ApplicationFormatToggle = ({
  isEditRoute,
  onSelect,
  selected
}) => {
  const className = classNames({
    'application-format-toggle': true,
    'crop-protection-input-half-width': !isEditRoute,
    'crop-protection-input-full-width': isEditRoute
  });

  const options = [{
    id: APPLICATION_FORMAT.sprayed,
    value: getMessage('liquid')
  }, {
    id: APPLICATION_FORMAT.spread,
    value: getMessage('granular')
  }];

  return (
    <div className={className}>
      <SegmentController
        handleClick={(e) => {
          if (selected !== e.id) {
            onSelect(e.id, isEditRoute);
          }
        }}
        selected={selected}
        tabs={options}
      />
    </div>
  );
};

ApplicationFormatToggle.propTypes = {
  isEditRoute: propTypes.bool.isRequired,
  onSelect: propTypes.func,
  selected: propTypes.string
};
